export const FORCE_RUN_SELECTION_ALL = 'all_events';
export const FORCE_RUN_SELECTION_FIRST = 'first_event_only';
export const FORCE_RUN_SELECTION_SPECIFIC = 'specific_event';

export const normalizeForceRunSelection = (value) => {
  const normalized = String(value || FORCE_RUN_SELECTION_ALL).trim().toLowerCase();

  if (normalized === FORCE_RUN_SELECTION_FIRST) {
    return FORCE_RUN_SELECTION_FIRST;
  }

  if (
    normalized === FORCE_RUN_SELECTION_SPECIFIC
    || normalized === 'specific'
    || normalized === 'timeevent_id'
    || normalized === 'timeevent'
  ) {
    return FORCE_RUN_SELECTION_SPECIFIC;
  }

  return FORCE_RUN_SELECTION_ALL;
};

export const normalizePositiveInteger = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsedValue = Number(value);
  if (!Number.isInteger(parsedValue) || parsedValue <= 0) {
    return null;
  }

  return parsedValue;
};

export const normalizeNonNegativeInteger = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsedValue = Number(value);
  if (!Number.isInteger(parsedValue) || parsedValue < 0) {
    return null;
  }

  return parsedValue;
};

export const buildForceRunPayload = ({
  caseid,
  exportId,
  selection = FORCE_RUN_SELECTION_ALL,
  timeeventId = null,
  customData = null,
  persistent = false,
}) => {
  const payload = {
    command: 'forceRun',
    caseid,
    export_id: exportId,
    allow_disabled: true,
    persistent: persistent === true,
  };

  const normalizedSelection = normalizeForceRunSelection(selection);
  if (normalizedSelection === FORCE_RUN_SELECTION_FIRST) {
    payload.timeevent_limit = 1;
  } else if (normalizedSelection === FORCE_RUN_SELECTION_SPECIFIC) {
    const normalizedTimeeventId = normalizePositiveInteger(timeeventId);
    if (!normalizedTimeeventId) {
      throw new Error('A valid time event id is required for a specific test run.');
    }
    payload.timeevent_id = normalizedTimeeventId;
  }

  if (customData && typeof customData === 'object' && !Array.isArray(customData) && Object.keys(customData).length > 0) {
    payload.customData = customData;
  }

  return payload;
};
